module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-resort-2.da1974ad.jpg";